import styles from "./AscImageList.module.scss";
import { useDrop } from "react-dnd";
import { QuizDraggableActivityItem } from "@ascendnow/shared";
import classNames from "classnames";

export interface AscImageListProps {
  className?: string;
  id: string;
  children?: React.ReactNode;
}

export default function AscImageList({
  className,
  id,
  children,
}: AscImageListProps) {
  const [_, drop] = useDrop(() => ({
    accept: QuizDraggableActivityItem,
    drop: () => ({ id }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));
  return (
    <div className={classNames(styles.ground, className)} ref={drop}>
      {children}
    </div>
  );
}
